module.exports = __webpack_public_path__ + "b1582df68eb59aca2666d06e47c875a2.svg";